import React from "react";
import { useTranslation } from "react-i18next";
import UploadAssistanceData from "./UploadAssistanceData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataAssistanceScreen = () => {
  debugLogPages(':: ImportDataAssistanceScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataAssistance" />

      <div className="d-flex justify-content-center page-title">{t("admin.importdata.assistance.title")}</div>

      <hr className="line-hr" />

        <div>
        <UploadAssistanceData />
        </div>
      
    </>
  );
};

export default ImportDataAssistanceScreen;
